import InputFiled from "../common/inputFiled";

const InputFiledIcon = (props: any) => {
  let icon = props.icon ?? "";
  let value = props.value ?? "";
  let name = props.name ?? "";
  let type = props.type ?? "";
  let min = props.min ?? "";
  return (
    <div className="row">
      <div className="col-lg-2 text-right pt-4">
        <span className="material-symbols-outlined pt-3">
          {icon}
        </span>
      </div>
      <div className="col-lg-6 p-lg-0">
        <label>Max</label>
        <InputFiled min={min} value={value} handleChange={props.handleChange} type={type} name={name} />
      </div>
    </div>
  );
}

export default InputFiledIcon